export default "__VITE_ASSET__RNUxFQ$G__"